export function test() {
	return null;
}

export function getOS() {
	const { userAgent } = window.navigator;
	const { platform } = window.navigator;
	const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
	const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
	const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
	let os: any = null;

	if (macosPlatforms.indexOf(platform) !== -1) {
		os = 'MacOS';
	} else if (iosPlatforms.indexOf(platform) !== -1) {
		os = 'iOS';
	} else if (windowsPlatforms.indexOf(platform) !== -1) {
		os = 'Windows';
	} else if (/Android/.test(userAgent)) {
		os = 'Android';
	} else if (!os && /Linux/.test(platform)) {
		os = 'Linux';
	}

	// @ts-ignore
	document.documentElement.setAttribute('os', os);
	return os;
}

export const hasNotch = () => {
	/**
	 * For storybook test
	 */
	const storybook = window.location !== window.parent.location;
	// @ts-ignore
	const iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
	const aspect = window.screen.width / window.screen.height;
	const aspectFrame = window.innerWidth / window.innerHeight;
	return (
		(iPhone && aspect.toFixed(3) === '0.462') || (storybook && aspectFrame.toFixed(3) === '0.462')
	);
};

export const mergeRefs = (refs: any[]) => {
	return (value: any) => {
		refs.forEach((ref) => {
			if (typeof ref === 'function') {
				ref(value);
			} else if (ref != null) {
				ref.current = value;
			}
		});
	};
};

export const randomColor = () => {
	const colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

	const color = Math.floor(Math.random() * colors.length);

	return colors[color];
};

export const priceFormat = (price: number) => {
	return price.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
};

export const average = (array: any[]) => array.reduce((a, b) => a + b) / array.length;

export const percent = (value1: number, value2: number) =>
	Number(((value1 / value2 - 1) * 100).toFixed(2));

export const getFirstLetter = (text: string, letterCount = 2): string =>
	// @ts-ignore
	text
		.toUpperCase()
		.match(/\b(\w)/g)
		.join('')
		.substring(0, letterCount);

export const debounce = (func: (arg0: any) => void, wait = 1000) => {
	let timeout: string | number | NodeJS.Timeout | undefined;

	return function executedFunction(...args: any[]) {
		const later = () => {
			clearTimeout(timeout);
			// @ts-ignore
			func(...args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
};

export const generateTransactionID = (separator?: any | undefined) => {
	const delim = separator || '-';

	function S4() {
		// eslint-disable-next-line no-bitwise
		return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
	}

	return S4() + S4() + delim + S4() + delim + S4() + delim + S4() + delim + S4() + S4() + S4();
};

export const generatePlaceholderArray = (numOfElements: number = 3) => {
	const placeholderArray: any = [];
	for (let i = 0; i < numOfElements; i += 1) {
		placeholderArray.push({ skeleton: true });
	}
	return placeholderArray;
};

export const getMenuByCategory = (menuObject) => {
	const result = {};

	Object.keys(menuObject).forEach((key) => {
		const item = menuObject[key];
		const category = item.category || 'other';

		if (!result[category]) {
			result[category] = {};
		}

		result[category][key] = item;
	});

	return result;
};

// Ottiene tutti i menu visibili (non nascosti)
export const getVisibleMenuItems = (menuObject, isClient = false, role = '') => {
	// Filtra gli elementi in base alle condizioni di visibilità
	const filteredMenu = Object.keys(menuObject)
		.filter((key) => {
			const item = menuObject[key];

			// Nascondi se adminHide è true E l'utente è ADMIN E non è un cliente
			if (item.adminHide && role === 'ADMIN' && !isClient) {
				return false;
			}

			// Mantieni la logica esistente per hide
			if (item.hide && isClient) {
				return false;
			}

			return true;
		})
		.reduce((obj, key) => {
			const item = menuObject[key];
			obj[key] = { ...item };

			// Applica la stessa logica ricorsivamente ai sottomenu
			if (item.subMenu) {
				obj[key].subMenu = getVisibleMenuItems(item.subMenu, isClient, role);
			}

			return obj;
		}, {});

	return filteredMenu;
};

// Ottiene il percorso completo di un menu
export const getMenuPath = (menuItem) => {
	return menuItem?.path || '';
};
